import {Injectable,} from '@angular/core';
import {StringUtil,} from '@services/index';
import {InputValidMessageVO, MessageOrigin, MessageOriginVO, MessageVO,} from '@models/index';

@Injectable({
  providedIn: 'root',
})
export class MessageProvider {
  private messageOriginByMessageId: Map<string, MessageOriginVO> = new Map<string, MessageOriginVO>();

  constructor(
    private stringUtil: StringUtil
  ) {
    // メッセージマスタ情報をメッセージIDをキーとしてMapに保存する
    MessageOrigin.MESSAGE_ORIGINS.forEach((messageOrigin: MessageOriginVO) => {
      this.messageOriginByMessageId.set(messageOrigin.messageId, messageOrigin)
    });
  }

  /**
   * [一般開発者利用可]
   * パラメータ埋め込み前のメッセージ取得処理
   * @param messageId メッセージID
   */
  getOriginMessage(messageId: string): MessageOriginVO | undefined {
    return this.messageOriginByMessageId.get(messageId);
  }

  /**
   * [一般開発者利用可]
   * メッセージVOを受取り、メッセージIDと埋め込みパラメータからメッセージを作成し、返却する
   * @param {MessageVO} messageVO 生成したいメッセージ文字列のメッセージのVO
   * @param {boolean} withMessageId trueの場合は「メッセージID:メッセージ」形式、falseの場合は「メッセージ」形式。
   * ただし、messageVOにmessageがセットされている場合はその文字列をそのまま返却。
   */
  getMessageString(messageVO: MessageVO, withMessageId = false): string | null {
    const messageOrigin: MessageOriginVO | undefined = this.getOriginMessage(messageVO.messageId);

// ToDo 「messageContent」が意図的に空の場合は、エラーにしたくない
//    if (!messageOrigin || this.stringUtil.isEmpty(messageOrigin.messageContent)) {

    if (!messageOrigin) {
      console.error('メッセージIDが存在しません。messageVO:', messageVO);
      if (messageVO.message) {
        return messageVO.message;
      } else {
        return null;
      }
    }
    let messageContent: string = messageOrigin.messageContent;
    if (messageVO.messageParams) {
      messageVO.messageParams.forEach((param: string | number, index: number) => {
        if (typeof param === 'number') {
          param = param.toString();
        }
        messageContent = messageContent.replace(new RegExp('\\{' + (index + 1) + '\\}', 'g'), param);
      })
    }
    if (withMessageId) {
      return messageVO.messageId + ':' + messageContent;
    } else {
      return messageContent;
    }
  }

  /**
   * [一般開発者利用可]
   * InputValidation用メッセージVOを受取り、メッセージIDと埋め込みパラメータからメッセージを作成し、返却する
   * @param inputValidationMessageVO 生成したいメッセージ文字列の入力バリデーション用メッセージのVO
   * @param withMessageId trueの場合は「メッセージID:メッセージ」形式、falseの場合は「メッセージ」形式。
   * ただし、messageVOにmessageがセットされている場合はその文字列をそのまま返却。
   */
  getMessageStringForInputValidation(
    inputValidMessageVO: InputValidMessageVO, withMessageId = false
  ): string | null {
    const messageOrigin: MessageOriginVO | undefined = this.getOriginMessage(inputValidMessageVO.messageId);
    if (!messageOrigin || this.stringUtil.isEmpty(messageOrigin.messageContent)) {
      console.error('メッセージIDが存在しません。inputValidMessageVO:', inputValidMessageVO);
      if (inputValidMessageVO.message) {
        return inputValidMessageVO.message;
      } else {
        return null;
      }
    }
    let messageContent: string = messageOrigin.messageContent;
    if (inputValidMessageVO.messageParams) {
      inputValidMessageVO.messageParams.forEach((param: string | number, index: number) => {
        if (typeof param === 'number') {
          param = param.toString();
        }
        messageContent = messageContent.replace(new RegExp('\\{' + (index + 1) + '\\}', 'g'), param);
      })
    }
    // Gridに対してバリデーションエラーが発生した場合のメッセージの加工
    if (inputValidMessageVO.itemPath != null) {
      if (inputValidMessageVO.itemPath.length >= 5) {
        // ページング有の一覧の項目は、ページNoと行Noを表示
        const rowNo = inputValidMessageVO.itemPath[3];
        const pageNo = inputValidMessageVO.itemPath[4];
        messageContent = pageNo + 'ページ' + rowNo + '行目:' + messageContent;
      } else if (inputValidMessageVO.itemPath.length >= 4) {
        // ページング無(スクロール)の一覧の項目は、行Noを表示
        const rowNo = inputValidMessageVO.itemPath[3];
        messageContent = rowNo + '行目:' + messageContent;
      }
    }
    if (withMessageId) {
      return inputValidMessageVO.messageId + ':' + messageContent;
    } else {
      return messageContent;
    }
  }

}
